import themeable from '@base/react-utils/themeable'

import PopoverBalloon from './PopoverBalloon'

import baseTheme from './DropdownBalloon.css'

// instead of creating a HOC, we extend the original Popover and only apply our theme
@themeable(baseTheme)
class DropdownBalloon extends PopoverBalloon {
  static displayName = 'DropdownBalloon'
}

export default DropdownBalloon
